import * as React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Grid, Loader } from 'semantic-ui-react';

import { Card, List } from '../..';
import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import analytics from '../../../shared/services/analytics/analytics';

import { AnnouncementsMainPropsGeneric } from './types';
import { useCallback } from 'react';

const AnnouncementsMain = ({ isFetching, data, getAnnouncements, handleMakeItScroll, intl }: AnnouncementsMainPropsGeneric) => {
  const handleSeeAllClick = useCallback(() => {
    analytics.trackCustomEvent('dashboard_click_announcement_see_all');
  }, []);

  return (
    <Grid.Column tablet={8} mobile={16} computer={5}>
      <Card
        title={intl.formatMessage({ id: 'dashboardMain.announcements', defaultMessage: localeData.en['dashboardMain.announcements'] })}
        headerLink="/messages/announcements"
        headerLinkLabel={intl.formatMessage({
          id: 'dashboardMain.dashboardMiddleUpperRow.seeAll',
          defaultMessage: localeData.en['dashboardMain.dashboardMiddleUpperRow.seeAll'],
        })}
        onHeaderLinkClick={handleSeeAllClick}
      >
        {isFetching ? (
          <div className="'dashboard__loader">
            <Loader active={true} inline="centered" size="massive" />
          </div>
        ) : (
          <List
            title={intl.formatMessage({
              id: 'dashboardMain.dashboardMiddleUpperRow.mostRecent',
              defaultMessage: localeData.en['dashboardMain.dashboardMiddleUpperRow.mostRecent'],
            })}
          >
            <div>
              {data && data.size > 0 ? (
                <ul className="list__items">
                  {data.map((announcement: any, index: number) => {
                    const onClick = () => handleMakeItScroll(announcement.get('id'), 'dashboard-announcements');

                    return (
                      <li
                        key={`${announcement.get('id')}-${index}`}
                        className={addModifiers('list__item', announcement.get('read') === false ? ['bullet-highlight'] : [])}
                      >
                        <Link to={'/messages/announcements'} onClick={onClick}>
                          {announcement.get('title') !== '' && announcement.get('title') !== null
                            ? `${announcement.get('title')}`
                            : `Announcement ${index + 1}`}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              ) : (
                <div>
                  <FormattedMessageHelper id="announcements.none" />
                  <div className="button-refresh__content">
                    <button className="button button--refresh" onClick={getAnnouncements} />
                  </div>
                </div>
              )}
            </div>
          </List>
        )}
      </Card>
    </Grid.Column>
  );
};

export default injectIntl(AnnouncementsMain);
